var map = {
	".": 35,
	"./": 35,
	"./GraphQLLanguageService": 70,
	"./GraphQLLanguageService.js": 70,
	"./GraphQLLanguageService.js.flow": 198,
	"./autocompleteUtils": 51,
	"./autocompleteUtils.js": 51,
	"./autocompleteUtils.js.flow": 199,
	"./getAutocompleteSuggestions": 43,
	"./getAutocompleteSuggestions.js": 43,
	"./getAutocompleteSuggestions.js.flow": 200,
	"./getDefinition": 52,
	"./getDefinition.js": 52,
	"./getDefinition.js.flow": 201,
	"./getDiagnostics": 54,
	"./getDiagnostics.js": 54,
	"./getDiagnostics.js.flow": 202,
	"./getHoverInformation": 55,
	"./getHoverInformation.js": 55,
	"./getHoverInformation.js.flow": 203,
	"./getOutline": 69,
	"./getOutline.js": 69,
	"./getOutline.js.flow": 204,
	"./index": 35,
	"./index.js": 35,
	"./index.js.flow": 205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;